import { Component, h, Prop, Host, Element } from '@stencil/core';

@Component({
    tag: 'sew-ws-career-slide',
    styleUrl: 'sew-ws-career-slide.scss',
    shadow: true,
})
export class SewWsCareerSlide {
    @Element() host: HTMLSewWsCareerSlideElement;
    @Prop() value: string;
    @Prop() description: string;
    @Prop() active: boolean;

    private wrapDigits(value: string) {
        const stringArray = value.split('');

        return stringArray.map(char => {
            return <span>{char}</span>;
        });
    }

    render() {
        return (
            <Host class={{ '--active': this.active }}>
                <div class="line-top"></div>
                <div class="value">{this.wrapDigits(this.value)}</div>
                <div class="description">{this.description}</div>
                <div class="line-bottom"></div>
            </Host>
        );
    }
}
